import { DOCUMENTS_DUCK, DOCUMENT_URL_STATUS } from '../../core/actions'

// Find Document Ids from a json recursively.
// { document_id: val }
const findDocIds = json => {
  const docIds = []
  const findDocIdsHelper = obj => {
    if (typeof obj !== 'object' || obj === null) {
      return
    }
    Object.entries(obj).forEach(([key, value]) => {
      if (key === 'document_id') {
        docIds.push(value)
      }
      findDocIdsHelper(value)
    })
  }

  findDocIdsHelper(json)
  return docIds
}

export const extractDocumentIds = json => dispatch => {
  dispatch({ type: DOCUMENTS_DUCK.ADD_EXTRACTED_DOC_IDS, payload: { documentIdsList: findDocIds(json) } })
}

export const getDocUrlsAction = docIds => (authAxios, dispatch) => {
  dispatch({ type: DOCUMENTS_DUCK.SEARCH_DOC_ID_PENDING })
  authAxios
    .post('/api/v3/documents', { ids: docIds })
    .then(({ data }) => {
      dispatch({ type: DOCUMENTS_DUCK.SEARCH_DOC_ID_SUCCESS, payload: { docUrlMap: data } })
    })
    .catch(err => {
      console.error(err)
      dispatch({ type: DOCUMENTS_DUCK.SEARCH_DOC_ID_FAILURE, payload: err.message })
    })
}

export const DocumentsInitialState = {
  docUrlMap: {},
  isLoading: false,
  error: null,
}

/**
 * We ll get a json from a deals call
 * Extract documentIds from that json
 * Save the ids into a map
 * Watch that map and for every change to that map. Trigger a documents call with only the ids that have no success status associated with it.
 * Response needs to be parsed and fed into the map that alters resp. ids
 *
 * In case of internet issues. The call will just fail and not handled.
 *
 */
export const DocumentsReducer = (state, { type, payload }) => {
  switch (type) {
    case DOCUMENTS_DUCK.ADD_EXTRACTED_DOC_IDS: {
      const newIds = {}
      payload.documentIdsList.forEach(docId => {
        if (docId && !state.docUrlMap[docId]) {
          newIds[docId] = { status: DOCUMENT_URL_STATUS.idle }
        }
      })
      return { ...state, docUrlMap: { ...state.docUrlMap, ...newIds } }
    }

    case DOCUMENTS_DUCK.SEARCH_DOC_ID_PENDING:
      return { ...state, isLoading: true }

    case DOCUMENTS_DUCK.SEARCH_DOC_ID_SUCCESS: {
      const newResp = state.docUrlMap
      Object.entries(payload.docUrlMap).forEach(([key, val]) => {
        newResp[key] = val
      })
      return { ...state, isLoading: false, docUrlMap: newResp }
    }

    case DOCUMENTS_DUCK.SEARCH_DOC_ID_FAILURE:
      return { ...state, isLoading: false, error: payload }
    default:
      return state
  }
}
